import React from 'react';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    element?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[85vh] flex items-center pt-16 pb-12 overflow-hidden bg-[#FDFBF7]" data-id="element-74">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-75">
        <div className="absolute -top-20 -right-20 w-96 h-96 bg-orange-100 rounded-full blur-3xl opacity-50" data-id="element-76" />
        <div className="absolute top-40 -left-20 w-72 h-72 bg-stone-200 rounded-full blur-3xl opacity-50" data-id="element-77" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-78">
        <div className="grid md:grid-cols-2 gap-8 items-center max-w-6xl mx-auto" data-id="element-79">
          <div className="space-y-6 text-center md:text-left" data-id="element-80">
            <div className="space-y-3" data-id="element-81">
              <p className="text-stone-500 font-medium italic text-base" data-id="element-82">
                Hay un tipo de cansancio que no se ve...
              </p>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-stone-900 leading-[1.1]" data-id="element-83">
                Habla con tus papás sin terminar{' '}
                <span className="text-orange-700" data-id="element-84">peleando</span>.
              </h1>
              <p className="text-lg md:text-xl text-stone-600 font-light leading-relaxed" data-id="element-85">
                No te falta amor. <br className="hidden md:block" data-id="element-86" />
                Te falta un{' '}
                <span className="font-medium text-stone-800" data-id="element-87">idioma común</span>
                .
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-center md:justify-start" data-id="element-88">
              <Button size="lg" onClick={scrollToPricing} withIcon data-id="element-89">
                Quiero mejorar la relación
              </Button>
            </div>

            <p className="text-sm text-stone-500 max-w-md mx-auto md:mx-0" data-id="element-90">
              Para hijos/as adultos que quieren paz, respeto y conexión sin
              volverse terapeutas de sus padres.
            </p>
          </div>

          <div className="relative mx-auto w-full max-w-md md:max-w-full flex justify-center" data-id="element-91">
            <div className="relative" data-id="element-92">
              <div className="absolute inset-0 bg-orange-200 rounded-2xl rotate-3 transform scale-95 blur-sm" data-id="element-93" />
              <img src="https://cdn.magicpatterns.com/uploads/jDTfNsZx964hmUHsFxtcz5/ChatGPT_Image_26_ene_2026,_18_35_22_ebook_puestes_de_palabras_2.png" alt="Puentes de Palabras Ebook Cover" className="relative rounded-xl shadow-2xl w-full max-w-[280px] md:max-w-[340px] object-cover transform transition-transform duration-700 hover:scale-[1.02]" data-id="element-94" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}